import { useEffect, useMemo } from 'react';

const HotkeyPattern = /\s*((?:ctrl|alt|shift)(?:\s*\+\s*(?:ctrl|alt|shift))*)\s*\+\s*([a-z0-9]+)/i;

export default function useHotkey(hotkey, cb, deps = []) {
    const { modifiers, key } = useMemo(() => {
        const [, modifiers, key] = HotkeyPattern.exec(hotkey);

        return {
            modifiers: modifiers.split(/\s*\+\s*/).map(m => m.toLowerCase()),
            key: key.toLowerCase(),
        };
    }, [hotkey]);

    useEffect(() => {
        /** @param {KeyboardEvent} event */
        const listener = event => {
            if (event.key !== key) return;
            if (modifiers.some(m => !event[`${m}Key`])) return;

            event.preventDefault();
            event.stopPropagation();

            cb();
        };

        window.addEventListener('keydown', listener);

        return () => window.removeEventListener('keydown', listener);
    }, [key, ...deps]);
}